<template>
    <div class="login-header d-flex align-items-center">
      <div class="dropdown">
        <button class="btn btn-primary dropdown-toggle d-flex align-items-center" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
          <div class="profile-photo">
            <img :src="profilePhoto" alt="Profile Photo" />
          </div>
          <span class="ms-2">{{ firstName }}</span>
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li><a class="dropdown-item" href="#" @click="logout">Logout</a></li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // Example data, you can replace this with actual props or data from API/localStorage
        firstName: 'John',
        profilePhoto: 'https://via.placeholder.com/40' // Replace with actual URL
      }
    },
    methods: {
      logout() {
        // Add your logout logic here
        console.log('Logging out...');
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .login-header {
    .dropdown {
      .btn {
        display: flex;
        align-items: center;
        padding: 0.35rem 0.5rem;
        border-radius: 0.375rem;
  
        .profile-photo {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
  
          img {
            width: 100%;
            height: auto;
            border-radius: 50%;
          }
        }
  
        span {
          font-size: 1rem;
          color: #fff;
        }
      }
  
      .dropdown-menu {
        min-width: 100%; /* Adjust as needed */
        padding: 0.5rem 0;
        border-radius: 0.375rem;
        background-color: #f8f9fa;
  
        .dropdown-item {
          cursor: pointer;
        }
      }
    }
  
    /* Media Queries for responsiveness */
    @media (max-width: 769px) {
      .login-header {
        .dropdown {
          .btn {
            padding: 0.25rem 0.5rem;
  
            .profile-photo {
              width: 25px;
              height: 25px;
            }
  
            span {
              font-size: 0.875rem; /* Adjust font size for smaller screens */
            }
          }
  
          .dropdown-menu {
            min-width: 120px; /* Adjust as needed */
          }
        }
      }
    }
  
    @media (max-width: 500px) {
      .login-header {
        .dropdown {
          .btn {
            padding: 0.2rem 0.4rem;
  
            .profile-photo {
              width: 20px;
              height: 20px;
            }
  
            span {
              font-size: 0.75rem; /* Adjust font size for even smaller screens */
            }
          }
  
          .dropdown-menu {
            min-width: 100px; /* Adjust as needed */
          }
        }
      }
    }
  }
  </style>
  